import { useQuery, QueryClient } from 'react-query'
import { getJSON } from 'common/services/api'
import { getQueryParams } from 'utils/getQueryParams'
import { useParams } from 'react-router-dom'
import { CommonErrors, GP_TYPE, Resident } from '@lmc/ts-common'
import { GPConnectResponse } from '@lmc/ts-common'
import { useSelector } from 'react-redux'

export const useGPdata = (
  type: GP_TYPE,
  body?: { startDate?: string; endDate?: string }
) => {
  const params = useParams()

  const residentId = params?.id

  const residents = useSelector(
    (state: { data: { residents: Resident[] } }) => state.data.residents
  )
  const nhsNumber =
    residents.find((resident: Resident) => resident.id === residentId)
      ?.nhsNumber ?? ''

  const { isLoading, data, refetch, error } = useQuery<GPConnectResponse>(
    [`gp`, type, body?.startDate, body?.endDate, nhsNumber, residentId],
    () =>
      getJSON({
        url: `/services/gp-connect/${residentId}/${type}?${getQueryParams(
          body || {}
        )}`,
      }),
    {
      enabled: !!residentId,
    }
  )

  const finalError: FinalError =
    error ||
    (data?.message || data?.code
      ? { message: data?.message, code: data?.code }
      : null)

  return {
    data,
    isLoading,
    refetch,
    error: finalError || null,
  }
}

export const handleGPCInvalidate = (queryClient: QueryClient) => {
  queryClient.invalidateQueries(['gp'])
}

type FinalError = {
  message?: string
  code?: string | CommonErrors.Codes
} | null
